import { Text, TextProps } from '@chakra-ui/react';
import { ReactElement } from 'react';

type Props = {
  textStyle: TextProps['textStyle'];
  color: string;
};

export const VSeparator = ({ textStyle, color }: Props): ReactElement => {
  return (
    <Text textStyle={textStyle} color={color}>
      |
    </Text>
  );
};
